import Repository from '@/repositories/repository'

const MarketsPageRepository = {
  async getPageTypeOneBySlug(queryParams: any = {}, slug: string, templateType: string) {
    const params = {
      page: '1',
      page_size: '100',
      ...queryParams
    }

    return await Repository(templateType + '|' + slug, 'page', params)
  }
}

export default MarketsPageRepository
